import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontWeight, Heading } from '@lili/lili-frontend-common';

export const ChangeNaicsHeader = () => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col justify-center items-center pb-[24px]' id='header'>
      <Heading.H5 fontWeight={FontWeight.MEDIUM} className='text-text-main-primary'>{t('CHANGE_NAICS.EDIT_NAICS_CODE')}</Heading.H5>
    </div>
  );
};

export default ChangeNaicsHeader;
